import { put, call } from 'redux-saga/effects';

import { getSavedFilingPeriodByIdRequest } from '@actions/savedFilingPeriod';
import * as actions from '@actions/standardTemplate';
import { getVatReturnEntryListSuccess } from '@actions/vatReturn';
import { saveManualAdjustments } from '@api/standardTemplate';

export const handleSaveManualAdjustments = function* ({ payload }) {
  try {
    const { savedFilingPeriodId, ...p } = payload;
    const response = yield call(saveManualAdjustments, p);
    if (response.isAxiosError)
      return yield put(actions.saveManualAdjustmentsFailure(response.message));
    yield put(actions.saveManualAdjustmentsSuccess(response));
    yield put(
      getVatReturnEntryListSuccess({
        ...response,
      })
    );

    yield put(getSavedFilingPeriodByIdRequest(savedFilingPeriodId));
  } catch (e) {
    yield put(actions.saveManualAdjustmentsFailure(e));
  }
};
